<template>
  <v-app v-resize="onResize">
    <vue-progress-bar></vue-progress-bar>
    <template v-if="!authenticated">
      <router-view></router-view>
    </template>
    <template v-if="authenticated">
      <!--弹出层-选择客户-->
      <v-dialog v-model="showSelectCompany" max-width="500px">
        <v-card>
          <v-card-title>请选择客户</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container grid-list-md class="xn-form">
              <v-layout wrap>
                <v-flex xs12>
                  <v-autocomplete
                    v-model="selectedCompanyId"
                    no-data-text="无可用数据"
                    :items="companies"
                    outline
                    solo
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-btn flat outline style="margin-right: 10px !important;" @click="showSelectCompany = false">
                    返回
                  </v-btn>
                  <v-btn color="info" outline style="margin-right: 10px !important;" @click="applySelectAllCompany">
                    显示全部客户
                  </v-btn>
                  <v-btn color="info" @click="applySelectCompany">确认</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!--弹出层-选择客户-->

      <v-navigation-drawer
        v-model="drawer"
        width="200"
        :mini-variant.sync="mini"
        hide-overlay
        :stateless="isMobile?null:true"
        app
        clipped
        class="drawer"
      >
        <div v-if="isMobile" class="top-bar-mobile">
          <v-btn flat color="#fff" @click="showSelectCompany = !showSelectCompany">
            {{
              $currentCompany
                ? "当前客户：" + $currentCompany.name
                : "请选择客户"
            }}
            <v-icon>fa-caret-down</v-icon>
          </v-btn>
        </div>

        <div v-if="!isMobile" class="top-bar">
          <v-icon color="#fff" @click.native.stop="mini = !mini">
            {{ mini?'fa-angle-double-right':'fa-angle-double-left' }}
          </v-icon>
        </div>

        <!--左侧菜单-->
        <v-list style="padding:0;">
          <v-list-tile
            v-for="item in navigationItems"
            :key="item.title"
            :class="item.name.includes(menuItem) ? 'menu-selected' : 'menu-normal'"
            @click.stop="clickMenu(item)"
          >
            <v-list-tile-action style="justify-content: center">
              <!--              <v-icon>{{ item.icon }}</v-icon>-->
              <i :class="`fas ${item.icon} fa-fw`" ></i>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <!--左侧菜单-->
      </v-navigation-drawer>

      <!-- pc 头部 -->
      <v-toolbar clipped-left app color="#2085F5" >
        <v-toolbar-side-icon
          v-if="isMobile"
          class="toolbar-side-icon"
          @click.native.stop="sideIconClicked()"
        ></v-toolbar-side-icon>

        <v-toolbar-title style="display: flex;align-items: center">
          <router-link to="/" style="display: flex;align-items: center;text-decoration: none;">
            <img class="logo" :src="logo" alt=""/>
            <span class="logo-text2">八爪鱼客户管理系统</span>
            <!--<img class="logo-text" :src="logoText"/>-->
          </router-link>
        </v-toolbar-title>

        <v-btn v-if="!isMobile" flat color="#fff" @click.stop="showSelectCompany = true">
          {{ $currentCompany ? "当前客户：" + $currentCompany.name : "请选择客户" }}
          <v-icon>fa-caret-down</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-menu offset-y >
          <v-btn slot="activator" fab icon small>
            <v-badge color="error">
              <template v-if="notifications.length>0" v-slot:badge>{{ notifications.length }}</template>
              <v-icon color="#fff">fa-bell</v-icon>
            </v-badge>
          </v-btn>
          <v-card class="notification-box">
            <div v-for="(item,i) in notifications" :key="i" class="py-3 px-3 notification-item">
              <a href="javascript:void(0)" @click="readNotification(item)">{{ item.content }}</a>
            </div>
            <div v-if="notifications.length>0" class="py-3 px-3 notification-item center" >
              <a href="javascript:void(0)" @click="readAll">全部已读</a>
            </div>

            <div v-else class="no-data" >
              <v-icon color="#ddd" size="56">fa-bell</v-icon>
              <span style="color:#999;" class="pt-2">还没有消息</span>
            </div>
          </v-card>
        </v-menu>
        <v-menu offset-y>
          <v-btn slot="activator" fab icon small>
            <v-badge color="error">
              <v-icon color="#fff">fa-user</v-icon>
            </v-badge>
          </v-btn>
          <v-list>
            <v-list-tile key="me" @click="me">
              <v-list-tile-title>个人中心</v-list-tile-title>
            </v-list-tile>
            <v-list-tile key="logoff" @click="logout">
              <v-list-tile-title>退出</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar>
      <!-- pc 头部 -->

      <!--内容-->
      <v-content>
        <v-container fluid class="xn-container">
          <router-view></router-view>
        </v-container>
      </v-content>

      <MaskLoading v-if="showLoading"/>
      <!--内容-->

      <!--底部-->
      <!--      <v-footer-->
      <!--        :inset="true"-->
      <!--        style="justify-content: center; text-align: center"-->
      <!--        app-->
      <!--      >-->
      <!--        <span>&copy; 八爪鱼客户管理系统 2019</span>-->
      <!--      </v-footer>-->
      <!--底部-->
    </template>
  </v-app>
</template>

<script>
  import {mapActions} from "vuex";
  import axios from "./axios";
  import {EventBus} from "./event";
  import {mapState} from "vuex";
  import MaskLoading from './components/MaskLoading';

  export default {
    name: "App",
    components: {
      MaskLoading
    },
    computed: mapState({
      showLoading: state => state.showLoading,
      companies: state => state.miniCompanies,
      companiesMap: state => state.miniCompaniesMap,
      notifications: state => state.notifications,
      menuItem() {
        return this.$route.name;
      },
      navigationItems() {
        let items = [
          {roleExcluded:'user',title: "首页", name: ["home"], icon: "fa-home"},
          {roleExcluded:'firm,user,branch,admin',title: "事务所管理", name: ["firms", "firm-form-add", "firm-form-edit","firm-form-detail"], icon: "fa-building"},
          {roleExcluded:'firm,user',title: "用户管理", name: ["users", "user-form-add", "user-form-edit", "user-form-detail"], icon: "fa-user-circle"},
          {roleExcluded:'user',title: "客户管理", name: ["companies", "company-form-add", "company-form-edit","company-form-detail"], icon: "fa-user-tie"},
          {roleExcluded:'user',title: "客户审核列表", name: ["company-reviews", "company-reviews-form-add", "company-reviews-form-edit","company-reviews-form-detail"], icon: "fa-user-slash"},
          {roleExcluded:'super,admin,branch,firm',title: "企业信息", name: ["company-info"], icon: "fa-info"},
          {roleExcluded:'',title: "合同管理", name: ["contracts-comp","contracts", "contract-form-add", "contract-form-edit", "contract-form-detail"], icon: "fa-file-contract"},
          {roleExcluded:'user',title: "企业文档", name: ["documents", "document-form-add", "document-form-edit","document-form-detail"], icon: "fa-file-word"},
          {roleExcluded:'',title: "待办事项", name: ["tasks", "task-form-add", "task-form-edit","task-form-detail"], icon: "fa-clock"},
          {roleExcluded:'user',title: "缴费记录",name: ["payments", "payment-form-add", "payment-form-edit","payment-form-detail"], icon: "fa-file-invoice-dollar"},
          {roleExcluded:'user',title: "报税记录",name: ["tax-filings", "tax-filing-form-add", "tax-filing-form-edit","tax-filing-form-detail"], icon: 'fa-donate'},
          {roleExcluded:'',title: "利润表", name: ["profits", "profit-form-add", "profit-form-edit","profit-form-detail"], icon: 'fa-coins'},
          {roleExcluded:'',title: "资产负债表",name: ["balance-sheets", "balance-sheet-form-add", "balance-sheet-form-edit","balance-sheet-form-detail"], icon: 'fa-chart-line'},
          {roleExcluded:'',title: "现金流量表",name: ["cashflows", "cashflow-form-add", "cashflow-form-edit","cashflow-form-detail"], icon: 'fa-search-dollar'},
          {roleExcluded:'user',title: "科目余额表",name: ["balances", "balance-form-add", "balance-form-edit","balance-form-detail"], icon: 'fa-dollar-sign'},
          {roleExcluded:'user',title: "开票信息", name: ["receipts", "receipt-form-add", "receipt-form-edit","receipt-form-detail"], icon: 'fa-receipt'},
          {roleExcluded:'user',title: "发票数量", name: ["receipt-counts"], icon: 'fa-calculator'},
          {roleExcluded:'user',title: "银行对账单",name: ["bank-statements", "bank-statement-form-add", "bank-statement-form-edit","bank-statement-form-detail"], icon: 'fa-file-invoice'},
        ];

        //除了超级管理员，任何角色都不能访问【事务所管理】
        //user，firm 不能访问【用户管理】
        //user只能访问(只读)【待办事项】【利润表】【资产负债表】【现金流量表】
        return items.filter(r=>!r.roleExcluded.includes(this.currentUser.role));
      },
      authenticated() {
        return localStorage.getItem('accessToken');
      }
    }),
    data() {
      return {
        //authenticated: !this.$router.currentRoute.path.endsWith("login"),
        drawer: true,
        mini: false,

        showSelectCompany: false,
        selectedCompanyId: null,
        isMobile: false,
        logo: require('./assets/logo2.png'),
        logoText: require('./assets/logo-text.png')
      };
    },
    methods: {
      ...mapActions(["fetchAccessToken", "fetchRefreshToken"]),
      readNotification(item){
        //点击通知
        if(item.notificationType==='FIRM_EXPIRE'){
          return;
        }
        let arr = [];
        arr.push(item.notificationId);
        axios
          .put("/notifications",{
            notificationIds:arr
          })
          .then((res) => {
            this.$store.dispatch("fetchNotifications");
            this.$router.push({
              name:'contract-form-detail',
              params:{contractId:item.contractId}
            });
          })
          .catch((reason) => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
          });
      },
      readAll(){
        //全部已读
        let arr = [];
        for(let n in this.notifications){
          arr.push(this.notifications[n].notificationId);
        }
        axios
          .put("/notifications",{
            notificationIds:arr
          })
          .then((res) => {
            this.$store.dispatch("fetchNotifications");
          })
          .catch((reason) => {
            this.$confirm(reason.response.data.message, {
              buttonFalseText: null
            });
          });
      },
      sideIconClicked(){
        this.drawer = !this.drawer;
        this.mini=false
      },
      logout: function () {
        axios
          .post("/logout")
          .then(() => {
            localStorage.clear();
            window.location = "/login";
          })
          .catch(() => {
            localStorage.clear();
            window.location = "/login";
          });
      },
      clickMenu(item) {
        //this.menuItem = item.name[0];
        if(this.currentUser.role==='user' && item.name[0]==='contracts-comp'){
          //如果说是客户的话，点击菜单直接跳到当前合同列表，不需要再展示公司列表了
          this.$router.push({
            name: 'contracts',
            params:{companyId:this.currentUser.companyId}
          });
        }else{
          this.$router.push({
            name: item.name[0]
          });
        }

      },
      me() {
        this.$router.push({
          name: 'me'
        });
      },
      applySelectAllCompany() {
        this.setCurrentCompany(null);
        this.showSelectCompany = false;
        this.selectedCompanyId = null;
        EventBus.$emit("refresh");
      },
      applySelectCompany() {
        if (this.selectedCompanyId !== null) {
          this.setCurrentCompany({
            id: this.selectedCompanyId,
            name: this.companiesMap[this.selectedCompanyId]
          });
        } else {
          this.setCurrentCompany(null);
        }
        this.showSelectCompany = false;
        EventBus.$emit("refresh");
      },
      onResize() {
        this.isMobile = window.innerWidth < 769;
        if (!this.isMobile) {
          this.drawer = window.innerWidth > 769;
        }
      }
    },
    created() {
      if (this.authenticated) {
        this.$store.dispatch("fetchMiniCompanies", {role:this.currentUser.role,callback:() => {
          this.selectedCompanyId = this.$currentCompany
            ? this.$currentCompany.id
            : null;
        }});

        this.$store.dispatch("fetchProvinces");
        this.$store.dispatch("fetchLevels");
        this.$store.dispatch("fetchStatuses");
        this.$store.dispatch("fetchTaxTypes");
        this.$store.dispatch("fetchContractTypes");
        this.$store.dispatch("fetchNotifications");

      }
    }
  };
</script>

<style>
  html {
    overflow-y: auto !important;
  }

  /*左侧菜单样式*/
  .v-toolbar__content {
    height: 52px !important;
  }

  main.v-content {
    padding-top: 52px !important;
  }

  aside.drawer {
    margin-top: 52px !important;
    max-height: calc(100% - 52px) !important;
  }

  .top-bar {
    width: 100%;
    height: 26px;
    background: rgba(21, 39, 60, 1);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .top-bar i {
    transform: scale(0.5);
    cursor: pointer;
  }

  .top-bar-mobile {
    background: rgba(21, 39, 60, 1);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .v-list__tile {
    height: 45px !important;
  }

  .drawer {
    background: #081728 !important;
  }

  .menu-selected {
    color: #fff !important;
    background: #020B16 !important;
    border-left: 4px solid #2085F5;
  }

  .menu-selected i {
    color: #fff !important;
  }

  .menu-normal {
    color: #9CA8B7 !important;
    border-left: 4px solid transparent;
  }

  .menu-normal i {
    color: #9CA8B7 !important;
  }

  .toolbar-side-icon i {
    color: #fff !important;
  }

  .logo {
    width: 30px;
    height: 30px;
    display: inline-block;
    margin-right: 10px;
  }

  .logo-text {
    width: 274px;
    height: 19px;
    display: inline-block;
  }
  .logo-text2{
    color:#fff;
    font-family: "Microsoft YaHei";
    font-size: 18px;
  }

  /*内容样式*/
  .xn-container {
    padding: 15px !important;
  }

  .wrapper {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 13px;
    padding: 18px 25px;
    background: #fff;
  }

  .wrapper .w-title {
    font-size: 16px;
    font-weight: bold;
  }

  .wrapper .w-title:before {
    content: '';
    width: 3px;
    height: 12px;
    background: rgba(32, 133, 245, 1);
    display: inline-block;
    margin-right: 12px;
  }

  /*.wrapper .w-select{*/
  /*  width:100%;*/
  /*  height:34px;*/
  /*  background:rgba(255,255,255,1);*/
  /*  border:1px solid rgba(204,204,204,1);*/
  /*  border-radius:3px;*/
  /*  padding-left: 14px;*/
  /*  font-size: 14px;*/
  /*}*/

  /*select*/
  .xn-form div[role='combobox'] .v-input__control .v-input__slot {
    border: 1px solid rgba(204, 204, 204, 1) !important;
    background: transparent !important;
    box-shadow: none !important;
    border-radius: 3px !important;
    min-height: 34px !important;
    font-size: 14px !important;
    margin-bottom: 0px !important;
  }

  .xn-form div[role='combobox'].v-input--is-focused .v-input__control .v-input__slot {
    border: 1px solid #2085F5 !important;
  }

  /*input*/
  .xn-form .v-input.v-text-field .v-input__control .v-input__slot {
    border: 1px solid rgba(204, 204, 204, 1) !important;
    background: transparent !important;
    box-shadow: none !important;
    border-radius: 3px !important;
    min-height: 34px !important;
    font-size: 14px !important;
    margin-bottom: 0px !important;
  }

  .xn-form .v-input .v-input__control .v-input__slot .v-text-field__slot {
    height: 32px !important;
  }

  .xn-form .v-textarea .v-input__control .v-input__slot .v-text-field__slot {
    height: auto !important;
  }

  .xn-form .v-textarea label {
    top: 7px !important;
  }

  .xn-form .v-textarea textarea {
    margin-top: 0 !important;
  }

  .xn-form .v-input .v-input__control .v-input__slot .v-text-field__slot input {
    margin-top: 0;
  }

  .xn-form .v-input.v-input--is-focused .v-input__control .v-input__slot {
    border: 1px solid #2085F5 !important;
  }

  .xn-form .v-input.v-input--is-disabled .v-input__control .v-input__slot {
    border: 1px solid transparent !important;
    margin-top: 1px;
  }

  .xn-form .v-input.v-input--is-disabled .v-input__append-inner {
    display: none;
  }

  .xn-form .v-input.v-input--is-disabled input,
  .xn-form .v-input.v-input--is-disabled textarea,
  .xn-form .v-input.v-input--is-disabled .v-select__selection {
    color: #000;
  }

  .xn-form .v-input--selection-controls {
    margin-top: 0 !important;
  }

  /*btn*/
  .xn-form .v-btn, .v-datatable .v-btn, .wrapper .v-btn {
    height: 32px !important;
    margin: 1px 0 0 0 !important;
    min-width: 0 !important;
    box-shadow: none !important;
  }

  .xn-form .v-btn.v-btn--small,
  .v-datatable .v-btn.v-btn--small,
  .wrapper .v-btn.v-btn--small {
    height: 26px !important;
  }


  /*table*/
  table.v-datatable {
    border: 1px solid rgba(223, 226, 228, 1);
  }

  .v-datatable thead {
    background: rgba(245, 247, 250, 1);
  }

  table.v-table thead tr {
    height: 48px !important;
  }

  table.v-table thead tr.v-datatable__progress {
    height: 0px !important;
  }

  tbody tr:nth-of-type(even) {
    background: rgba(249, 249, 249, 1);
  }

  table.v-datatable thead th:first-child {
    width: 10px;
  }
  table.v-datatable thead th:last-child {
    width: 100px;
  }

  .v-datatable__actions__range-controls .v-btn {
    /*display: none !important;*/
    margin: 8px !important;
  }
  .wrapper .v-btn.right{
    top:-5px;
  }
  /*.v-datatable__actions__range-controls .v-datatable__actions__pagination{*/
  /*  margin-top:15px !important;*/
  /*}*/

  /*表单页*/
  .form-panel {
    border: 1px solid rgba(223, 226, 228, 1);
    border-radius: 0px 0px 3px 3px;
    margin-top: 15px;
    border-top: none;
  }

  .form-panel .form-panel-head {
    height: 38px;
    background: rgba(245, 247, 250, 1);
    font-size: 16px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    padding: 6px 15px;
    border-bottom: 1px solid rgba(223, 226, 228, 1);
    border-top: 1px solid rgba(223, 226, 228, 1);
  }

  .form-panel .form-panel-body {
    padding: 30px;
  }

  .form-panel label {
    text-align: right;
    color: #999 !important;
  }

  label.required:before {
    content: '*';
    color: red;
    margin-right: 5px;
  }

  .btn-add-contract {
    display: block;
    width: 100%;
    height: 60px;
    background: rgba(225, 242, 250, 1);
    border: 1px dashed rgba(32, 133, 245, 1);
    margin-top: 25px;
    border-radius: 3px 3px 6px 6px;
    text-align: center;
    line-height: 58px;
    text-decoration: none;
  }

  label {
    font-size: 14px !important;
  }

  /*上传按钮*/
  .upload-btn span {
    color: #fff !important;
  }

  /*v stepper*/
  .v-stepper {
    box-shadow: none !important;
  }

  /*calendar*/
  .xn-date .v-text-field__slot label {
    left: 20px !important;
  }

  .xn-date .v-text-field__slot:before {
    content: '';
    width: 22px;
    height: 14px;
    display: block;
    background: url('./assets/icon-calendar.png') no-repeat;
  }

  /*detail*/
  .detail-btns {
    display: flex;
  }

  .detail-btns .btn-to-edit {
    margin-left: 10px !important;
  }

  .bold {
    font-weight: bold;
  }

  .money {
    color: #F14E4E;
  }
  p.detail-area{
    padding:7px 12px;
    overflow-wrap: break-word;
  }

  /*利润表*/
  .xn-table {
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
    font-size: 14px;
  }

  .xn-table thead {
    background: #ccc;
  }

  .xn-table td, .xn-table th {
    height: 35px;
    border: 1px solid rgba(223, 226, 228, 1);
  }

  .xn-table td:first-child,
  .xn-table td:nth-child(5) {
    padding-left: 6px;
  }

  .xn-table input {
    width: 100%;
    height: 35px;
    text-align: right;
    padding-right: 6px;
  }

  .xn-table input:disabled {
    color: #777;
  }

  /*fix iphone default*/
  input:disabled,
  textarea:disabled{
    opacity: 1 !important;
  }

  .xn-table .big {
    font-size: 16px;
    font-weight: bold;
  }

  .xn-table .bg {
    background: #eee;
  }

  .xn-table input.xn-error {
    background: rgba(255, 0, 0, 0.3);
  }


  .notification-box{
    width:350px;height: 350px;
  }
  .notification-box .no-data{
    display: flex;flex-direction: column;justify-content: center;align-items: center;height: 100%;
  }
  .notification-box .notification-item{
    border-bottom: 1px solid #eee;
    background: #fff;
  }
  .notification-box .notification-item.center a{
    color:green;
    width:100%;
    display: inline-block;
    text-align: center;
  }
  .notification-box a{
    text-decoration: none;

  }
  /*手机端样式*/
  @media screen and (max-width: 768px) {
    .wrapper {
      padding: 13px;
    }

    .xn-container {
      padding: 10px !important;
    }

    .form-panel-body {
      padding: 10px !important;
    }

    .logo-text2{
      font-size: 14px;
    }
  }
</style>
